export enum ROLE {
  SUPER_ADMIN = "SPADM",
  ADMIN = "CADM",
  SUBADMIN = "CSADM",
  SENDER = "CUSR",
}
